import {useEffect, useState} from "react";
import {useAuth} from "../../providers/AuthProvider";

const TABS = {
    RoleMatch: 'role-match',
    HireConfidence: 'hire-confidence',
};

const TAB_EVENT = 'CandidateFitTabs@changed';

/**
 * Selecting a tab on one tile selects it on every tile, so a client can scan a
 * whole list of candidates on the same measure. Held outside React so tiles
 * that mount later (pagination, filtering) pick up the current selection.
 */
let sharedTab;

const useSharedFitTab = () => {
    const {auth} = useAuth() || {};

    /*
    |--------------------------------------------------------------------------
    | TEMPORARY — staged rollout of Hire Confidence
    |--------------------------------------------------------------------------
    |
    | Hire Confidence is only exposed to users who can manage clients while the
    | scores are being validated against production data. Everyone else sees
    | Role Match exactly as they did before the tabs existed.
    |
    | To open it up to everyone: delete this flag, drop the third return value
    | below, and remove the two `canSeeHireConfidence` checks in
    | CandidateTileRedesign and TalentTileRedesign. Nothing else is gated.
    |
    */
    const canSeeHireConfidence = !!auth?.canManageClients();

    const [tab, setTab] = useState(() => sharedTab || TABS.RoleMatch);

    useEffect(() => {
        const handler = (nextTab) => setTab(nextTab);

        TB.event().provider().on(TAB_EVENT, handler);

        // Adopt a selection that was made before this tile mounted.
        if (sharedTab) {
            setTab(sharedTab);
        }

        return () => TB.event().provider().off(TAB_EVENT, handler);
    }, []);

    const selectTab = (nextTab) => {
        sharedTab = nextTab;
        TB.event(TAB_EVENT, nextTab);
    };

    // Pinned to Role Match for ungated users, so a selection made elsewhere in
    // the session can never leave them on a tab they cannot switch back from.
    return [canSeeHireConfidence ? tab : TABS.RoleMatch, selectTab, canSeeHireConfidence];
};

export default useSharedFitTab;